import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { THEME } from "../../constants";
import useSettingsState from "../../hooks/useSettingsState";

import useAppSelector from "../../hooks/useAppSelector";

import { selectAcceptedTermsOfService } from "../../redux/slices/legal";

const initialState = {
  theme: THEME.DEFAULT,
  setTheme: (layout: string) => {},
};

const ThemeContext = React.createContext(initialState);

interface ThemeProviderType {
  children: React.ReactNode;
}

function ThemeProvider({ children }: ThemeProviderType) {
  const [theme, setTheme] = useSettingsState("theme", THEME.DEFAULT);

  const acceptedTermsOfService = useAppSelector(selectAcceptedTermsOfService);

  const currentUrl = window.location.href;
  if (currentUrl.toLowerCase().indexOf("/confirm") <= 0) {
    if (!acceptedTermsOfService) {
      var newUrl = "/confirm?returnUrl=" + encodeURIComponent(currentUrl);
      return <Navigate to={newUrl} />;
    }
  }

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export { ThemeProvider, ThemeContext };
